/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
/* ------------------------- Internal Dependencies -------------------------- */
import {BackgroundImage} from 'atomic'
import { FirestoreList } from 'containers'

/* ------------------------------- Component -------------------------------- */
export default props => <FirestoreList
  delta='projectFilter'
  foundry='ProjectCard'
  itemStyled={{
    w: 1,
  }}
/>


// WEBPACK FOOTER //
// ./src/interface/foundry/Projects/ProjectsFirestoreList/index.js